"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _MicrophoneVolumeBar = require("./MicrophoneVolumeBar");
Object.keys(_MicrophoneVolumeBar).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MicrophoneVolumeBar[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _MicrophoneVolumeBar[key];
    }
  });
});